import { render, staticRenderFns } from "./sportsPlan.vue?vue&type=template&id=2975c87f&scoped=true&"
import script from "./sportsPlan.vue?vue&type=script&lang=js&"
export * from "./sportsPlan.vue?vue&type=script&lang=js&"
import style0 from "./sportsPlan.vue?vue&type=style&index=0&id=2975c87f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975c87f",
  null
  
)

export default component.exports